import { can, type Rol } from '@leadsphere/types';

import { useAuth } from './useAuth.js';

const ROLES_VALIDOS: readonly string[] = ['root', 'head', 'analista', 'kam', 'ads_manager', 'gerente_comercial', 'comercial', 'digital', 'CEO'];

// Permisos de la página de Catálogos (SRS-01 §8) — canManageAreaCatalogo es
// un permiso APARTE de canManageCatalogs (Prompt AA): root/head/kam/comercial
// gestionan Áreas, pero solo root/head/analista gestionan Giro/Origen/
// Plataforma/Tiers. Un mismo usuario puede tener uno sin el otro (ej. kam
// gestiona Áreas pero ve Giro/Origen/etc. en solo lectura).
export function useCanCatalogos() {
  const { user } = useAuth();
  const rol = user?.rol && ROLES_VALIDOS.includes(user.rol) ? (user.rol as Rol) : null;

  return {
    canManageCatalogs: rol !== null && can(rol, 'canManageCatalogs'),
    canManageAreaCatalogo: rol !== null && can(rol, 'canManageAreaCatalogo'),
  };
}
